var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-comparison-label grey--text text--darken-2"},[_c('v-icon',{staticClass:"mr-1",attrs:{"color":_vm.color,"size":"18"}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"field"},[_vm._v(_vm._s(_vm.field))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }